module.exports = __webpack_public_path__ + "static/media/gts35.701b4ad6.png";